<template>
  <input
    v-model="barcode"
    autocomplete="off"
    class="form-control"
    :name="name"
    :placeholder="placeholder"
    type="text"
  />
</template>

<script>
import cleanup from "../utils/barcode_cleanup"

export default {
  data() {
    return { barcode: cleanup(this.value) }
  },
  methods: {
    cleanup() {
      this.barcode = cleanup(this.barcode)
    },
  },
  props: ["name", "value", "placeholder"],
  watch: {
    barcode() {
      this.cleanup()
    },
  },
}
</script>
